export enum VARIANT_KEYS {
  BEST_PRICE = 'bestPrice',
  INSTANT_SHIP = 'instantShip',
  NEW_WITH_BOX_ISSUES = 'newWithBoxIssues',
  NEW_WITH_DEFECTS = 'newWithDefects',
  USED = 'used',
}
